import {gql} from "apollo-angular";
import {basePageableGraphqlField, baseResponseGraphqlField} from "../../../base.graphql";

export const SYSTEM_FIELDS = `
id
        systemUniqueId
        systemShortform
        systemName
        systemInstitution {
          id
          institutionUniqueId
          institutionName
          institutionShortform
          institutionPhysicalAddress
          institutionEmail
          institutionPostcode
          institutionWebsite
          institutionPhones
          institutionMapUrl
          institutionLogo
          institutionType
          institutionMinistry {
            id
            ministryUniqueId
            ministryName
          }
          institutionSector {
            id
            sectorUniqueId
            sectorCode
            sectorName
            sectorIcon
          }
          institutionRegion {
            id
            regionalUniqueId
            reginalName
            reginalPostcode
            napaId
          }
          institutionDistrict {
            id
            districUniqueId
            districName
            districPostcode
            napaId
            districParentRegion {
              id
              regionalUniqueId
              reginalName
              reginalPostcode
              napaId
            }
          }
          institutionWard {
            id
            wardUniqueId
            wardName
            wardPostcode
            napaId
            wardParentDistric {
              id
              districUniqueId
              districName
              districPostcode
              napaId
            }
          }
          institutionStreet {
            id
            streetUniqueId
            streetName
            streetPostcode
            napaId
            streetParentWard {
              id
              wardUniqueId
              wardName
              wardPostcode
              napaId
            }
          }
          institutionFunctions {
            id
            functionUniqueId
            functionDutyName
            functionCreateddate
            functionIsActive
          }
        }`

export const GET_ALL_INSTITUTION_NAMES = gql`
  query GetAllInstitutionSystems($filtering: InstitutionInternalSystemFilteringInputObject) {
    getAllInstitutionSystems(filtering: $filtering) {
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${SYSTEM_FIELDS}
      }
    }
  }`

export const CREATE_INSTITUTION_SYSTEM_MUTATION = gql`
  mutation CreateInstitutionSystemMutation($input: InstitutionInternalSystemInputObject!) {
    createInstitutionSystemMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${SYSTEM_FIELDS}
      }
    }
  }`

export const UPDATE_INSTITUTION_SYSTEM_MUTATION = gql`
  mutation UpdateInstitutionSystemMutation($input: InstitutionInternalSystemInputObject!) {
    updateInstitutionSystemMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${SYSTEM_FIELDS}
      }
    }
  }`


export const DELETE_INSTITUTION_SYSTEM_MUTATION = gql`
  mutation DeleteInstitutionSystemMutation($systemUniqueId: String!) {
    deleteInstitutionSystemMutation(systemUniqueId: $systemUniqueId) {
      ${baseResponseGraphqlField}
    }
  }`
